import { __makeTemplateObject } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Text } from '@elseu/sdu-titan';
import styled from 'styled-components';
import { Icon } from '../Icon/Icon.js';

/**
 * The styled component for the IconList
 */
var StyledIconList = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  padding: 0;\n  gap: ", ";\n  margin-bottom: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  padding: 0;\n  gap: ", ";\n  margin-bottom: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spacing[4];
}, function (_a) {
  var theme = _a.theme;
  return theme.spacing[8];
});
/**
 * The styled component for an item in the IconList
 */
var Item = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.spacing[4];
});
/**
 * The styled component for the text in an item of the IconList
 */
var StyledText = styled(Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  margin: 0;\n"], ["\n  display: inline-block;\n  margin: 0;\n"])));
/**
 * The IconList component
 *
 * @param {IconListProps} props - The props for the IconList component.
 * @returns {JSX.Element} The IconList component.
 */
var IconList = function (_a) {
  var items = _a.items,
    iconColor = _a.iconColor;
  return jsx(StyledIconList, {
    children: items.map(function (_a) {
      var text = _a.text,
        icon = _a.icon;
      return jsxs(Item, {
        children: [jsx(Icon, {
          icon: icon,
          size: 24,
          color: iconColor
        }), jsx(StyledText, {
          as: "p",
          type: "paragraph",
          children: text
        })]
      }, text);
    })
  });
};
var templateObject_1, templateObject_2, templateObject_3;

export { IconList, StyledIconList };
//# sourceMappingURL=IconList.js.map
